import { useOutletContext } from "react-router-dom";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";

import ProducerStatisticsView from "../views/ProducerStatisticsView";

export default function ProducerStatistics() {
	const { organization } = useOutletContext();
	const hasRight = useHasRight();

	if (!hasRight("productions.viewStatistics")) {
		return <Unauthorized />;
	}

	return <ProducerStatisticsView organization={organization} />;
}
